import React, { Component } from 'react'
import { Observable } from '@reactivex/rxjs'
import { range, pipe } from 'ramda'
import { interpolate } from 'd3-interpolate'
import { easeExpInOut as easing } from 'd3-ease'
import { format } from 'd3-format'

const totalDuration = 26000
const update = 20
const cost = format('.3f')
const maxWordLength = 7
const targetWordLength = 8
const origin = 'ⅷ'

class Selected extends Component {
  constructor(props) {
    super(props)
    this.state = { sample: '---' }
  }

  componentWillReceiveProps(nextProps) {
    const { selected } = this.props
    const nextSelected = nextProps.selected

    const currentSample = toText(selected)
    const nextSample = toText(nextSelected)

    if (currentSample === nextSample) return

    const f = trim(currentSample)
    const t = trim(nextSample)
    const maxLength = Math.max(t.length, f.length)
    const a = pad(f.split('').map(charCode), maxLength)
    const b = pad(t.split('').map(charCode), maxLength)
    const ι = pipe(interpolate(a, b), a =>
      a
        .map(Math.round)
        .map(fromCharCode)
        .join('')
    )

    if (this.ticker) this.ticker.unsubscribe()

    this.ticker = Observable.interval(update)
      .takeUntil(Observable.interval(totalDuration * 1.1))
      .map(i => i * update / totalDuration)
      .concat(Observable.of(1))
      .map(easing)
      .map(ι)
      .subscribe(i => this.setState({ i }))
  }

  render() {
    const { i } = this.state
    return (
      <span>{normalizeWordLength(i || origin)}</span>
    )
  }
}

export default Selected

function toText(selected) {
  if (!selected) return origin
  return `
  ${selected.get('iteration')} : ${cost(selected.get('cost'))} 
  ${selected.get('sample')}
  `
}

function normalizeWordLength(text) {
  return text.split(/\s/).reduce(splitLongWords, []).join(' ')
}

function splitLongWords(acc, word) {
  const length = word.length
  if (length < maxWordLength) acc.push(word)
  else {
    const letters = word.split('')
    const newLength = Math.round(length / Math.ceil(length / targetWordLength))
    while (letters.length) acc.push(letters.splice(0, newLength).join(''))

  }
  return acc
}

function charCode(character) {
  return character.charCodeAt(0)
}

function fromCharCode(code) {
  return String.fromCharCode(code)
}

function pad(a, length) {
  return a.concat(
    range(0, length - a.length).map(function() {
      return 32
    })
  )
}

function trim(string) {
  return string.replace(/^\s+/, '').replace(/\s+$/, '')
}



// WEBPACK FOOTER //
// ./Selected.js